export default class UpdateRoleModel {
  name?: string;

  isActive?:boolean;

  description?: string;

  accountType?: number;

  accessRightCodes:Array<string> = [];
}
